import * as React from 'react'
import {useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {api} from '../api/api'
import '../css/login.css'
import {errorSwitcher, isEnter, UNKNOWN_SERVER_ERROR, tagger} from '../util/util'

const Login = () => {
    const loginRef = useRef(null) as any

    const {t} = useTranslation('login')

    const [email, setEmail] = useState('')
    const [pass, setPass] = useState('')
    const [eEmail, setEEmail] = useState([])
    const [ePass, setEPass] = useState([])
    const [eOther, setEOther] = useState([])

    const updateErrors = (email, pass, other) => {
        setEEmail(email)
        setEPass(pass)
        setEOther(other)
    }

    const handleErrors = errors => {
        const parsed = errorSwitcher(errors)
        updateErrors(parsed.email, parsed.pass, parsed.other)
    }

    const login = async () => {
        updateErrors([], [], [])
        loginRef.current.classList.toggle('active')
        try {
            const response = await api.login(email, pass)
            if (response && response.redirectUrl) {
                window.location.href = response.redirectUrl
            }
        } catch (e) {
            loginRef.current.classList.toggle('active')
            handleErrors(e ? e.errors : UNKNOWN_SERVER_ERROR)
        }
    }

    return (
        <div className="common-pages-container text-center login-page">
            <img src="https://static.persona.ly/images/logo_persona.svg" />
            <p>{t('login to')}</p>

            {eOther && eOther.map(err => <div className="error" key={err}>{err}</div>)}

            <div className="contact-input-container">
                <input className={'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : '')} type="email" name="email" placeholder="&nbsp;"
                    onInput={e => setEmail(e.currentTarget.value)} onKeyPress={e => isEnter(e) && login()}
                />
                <span className="contact-input-label">{t('email a')}</span>
            </div>
            {eEmail && eEmail.map(err => <div className="error-small" key={err}>{err}</div>)}

            <div className="contact-input-container">
                <input className={'contact-input small-text' + (ePass.length > 0 ? ' error-input' : '')} type="password" name="pass" placeholder="&nbsp;"
                    onInput={e => setPass(e.currentTarget.value)} onKeyPress={e => isEnter(e) && login()}
                />
                <span className="contact-input-label">{t('pass')}</span>
            </div>
            {ePass && ePass.map(err => <div className="error-small" key={err}>{err}</div>)}

            <div className="contact-checkbox-c">
                <label className="remember-me-l">
                    <span className="remember-me-s">
                        <input className="remember-me-i" id="remember" type="checkbox" value="" />
                        <span className="remember-me-s-inner"></span>
                    </span>
                    <span>{t('remember me')}</span>
                </label>
                <Link className="forgot-pass" to="forgot_password">{t('forgot p')}</Link>
            </div>
            <button ref={loginRef} className="button-blue large animated button-login" onClick={login}>
                {t('login')}<img src="https://static.persona.ly/images/arrow.svg" />
            </button>
            <div className="to-register">{tagger(t('dont have a'), 'accent-text fw500', 'sign_up')}</div>
        </div>
    )
}

export default Login


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/login.tsx